import React, { Component } from 'react'
import {
  VictoryAxis,
  VictoryBar,
  VictoryChart,
  VictoryGroup,
  VictoryLegend,
  VictoryTheme,
} from 'victory'

const timepointColors = {
  baseline: '#8F7AB8', // soft purple
  previous: '#E3A857', // warm gold
  latest: '#4C9F8E',   // calming green-teal
}

class AssessmentComparisonGraph extends Component {
  normalizeAssessment = (
    score,
    minimum,
    maximum
  ) => {
    if (
      score === null ||
      score === undefined
    ) {
      return null
    }

    const percentage =
      ((score - minimum) /
        (maximum - minimum)) *
      100

    return Math.max(
      2,
      Math.min(100, percentage)
    )
  }

  getAssessmentGraphData = () => {
    const assessments = [
      {
        assessment: 'Depression',
        baseline: 14,
        previous: 1,
        latest: 0,
        minimum: 0,
        maximum: 27,
      },
      {
        assessment: 'Mania',
        baseline: 6,
        previous: 6,
        latest: 10,
        minimum: 0,
        maximum: 20,
      },
      {
        assessment: 'Anxiety',
        baseline: 14,
        previous: 0,
        latest: 0,
        minimum: 0,
        maximum: 21,
      },
      {
        assessment: 'Sleep',
        baseline: 14,
        previous: 5,
        latest: 6,
        minimum: 0,
        maximum: 21,
      },
      {
        assessment: 'Well-being',
        baseline: null,
        previous: 17,
        latest: 20,
        minimum: 0,
        maximum: 25,
      },
      /*{
        assessment: 'PWS/PW18',
        baseline: 44,
        previous: 68,
        latest: 52,
        minimum: 18,
        maximum: 126,
      },
      {
        assessment: 'DERS-18',
        baseline: 78,
        previous: 75,
        latest: 64,
        minimum: 18,
        maximum: 90,
      },*/
    ]

    const createGraphData = scoreKey =>
      assessments.map(item => ({
        x: item.assessment,
        y: this.normalizeAssessment(
          item[scoreKey],
          item.minimum,
          item.maximum
        ),
        score: item[scoreKey],
      }))

    return {
      assessments,
      baselineData:
        createGraphData('baseline'),
      previousData:
        createGraphData('previous'),
      latestData:
        createGraphData('latest'),
    }
  }

  render() {
    const assessmentGraph =
      this.getAssessmentGraphData()

    const allValues = [
      ...assessmentGraph.baselineData,
      ...assessmentGraph.previousData,
      ...assessmentGraph.latestData,
    ]
      .map(item => item.y)
      .filter(
        value =>
          value !== null &&
          value !== undefined
      )

    const highestValue =
      allValues.length > 0
        ? Math.max(...allValues)
        : 100

    const graphMaximum = Math.min(
      105,
      Math.ceil(
        (highestValue * 1.05) / 5
      ) * 5
    )

    const chartWidth = 450

    return (
      <div className="small-12 columns">
        <div className="title6">
          Assessment Score Comparison Chart
        </div>

        <VictoryChart
          width={chartWidth}
          height={150}
          theme={VictoryTheme.material}
          domain={{
            y: [0, graphMaximum],
          }}
          domainPadding={{
            x: 40,
          }}
          padding={{
            top: 35,
            bottom: 38,
            left: 20,
            right: 20,
          }}
        >
          <VictoryLegend
            x={(chartWidth - 245) / 3}
            y={10}
            orientation="horizontal"
            gutter={18}
            style={{
              labels: {
                fontSize: 8,
              },
            }}
            data={[
              {
                name: 'At Enrollment',
                symbol: {
                  fill: timepointColors.baseline,
                },
              },
              {
                name: 'Previous',
                symbol: {
                  fill: timepointColors.previous,
                },
              },
              {
                name: 'Now',
                symbol: {
                  fill: timepointColors.latest,
                },
              },
            ]}
          />

          <VictoryAxis
            tickValues={assessmentGraph.assessments.map(
              item => item.assessment
            )}
            style={{
              tickLabels: {
                fontSize: 7,
                angle: -45,
                textAnchor: 'end',
                padding: 2,
              },
            }}
          />

          <VictoryAxis
            dependentAxis
            tickFormat={() => ''}
            style={{
              tickLabels: {
                display: 'none',
              },
            }}
          />

          <VictoryGroup
            offset={9}
            colorScale={[
              timepointColors.baseline,
              timepointColors.previous,
              timepointColors.latest,
            ]}
          >
            <VictoryBar
              data={
                assessmentGraph.baselineData
              }
              barWidth={7}
            />

            <VictoryBar
              data={
                assessmentGraph.previousData
              }
              barWidth={7}
            />

            <VictoryBar
              data={
                assessmentGraph.latestData
              }
              barWidth={7}
            />
          </VictoryGroup>
        </VictoryChart>
      </div>
    )
  }
}

export default AssessmentComparisonGraph
